
import { PlycaDataService } from './plyca.service';
import { ProcedureDTO, ProcedureStatusDTO, ProcurementProjectDefinitionsDTO, ProcurementProjectStepsDefinitionDTO, ProfileDTO } from '../app/api/plyca-dtos';
import { Configuration } from '../app/conf/app.constants';
import { forkJoin, Observable, of, BehaviorSubject } from 'rxjs';
import { PaginationDTO } from '../app/api/PaginationModel';
import { catchError, tap, finalize, map, switchMap } from 'rxjs/operators';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { AppConfiguration } from '../app/conf/app.configuration';
import { UserService } from '../app/user.service';
import * as lodash from 'lodash';
import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseDirectiveObject } from '../app/components/common/base-directive-object';
import { PropertyService } from '../app/properties/property.service';
import { ProjectEntityDTO } from '../app/api/plyca-dtos-v2';
import { ControlPanelEditionProfiles, ControlPanelProfiles } from '../app/admin/controlPanel/controlPanel.const';

@Injectable()
export class ProfileService extends BaseDirectiveObject implements OnDestroy {

  allProfiles: ProfileDTO[];
  newDossierEnabled: boolean;
  exportsEnabled: boolean;
  exportProfiles: string;
  dossierInfoConf: any;
  controlPanelProfiles: Array<any> = [];
  controlPanelEditionProfiles: Array<any> = [];
  configurationLoaded = false;
  userHasPrepareProjectRoles = false;
  // control de fin de la inicialización del servicio
  public initCompleted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  constructor(private plycaService: PlycaDataService, private configuration: Configuration,
    private userService: UserService,
    private propertyService: PropertyService,
    private appConfig: AppConfiguration) {
    super();
  }

  public init(): Observable<PaginationDTO<ProfileDTO>> {
    this.initCompleted.next(false);
    this.configure();


    return this.plycaService
      .query<ProfileDTO>(this.configuration.PROFILES_SERVICE_URL)
      .pipe(
        tap((resp: PaginationDTO<ProfileDTO>) => {
          if (resp && resp.content) {
            this.allProfiles = resp.content;
          } else {
            this.allProfiles = [];
          }
        })
      );
  }

  public renew(): Observable<PaginationDTO<ProfileDTO>> {

    return this.init();
  }

  public clear(): void {
    this.allProfiles = [];
  }

  public getProfile(id: number): ProfileDTO {
    return this.allProfiles.find((profile: ProfileDTO) => +profile.identifier == id);
  }

  public getProfiles(): ProfileDTO[] {
    return this.allProfiles;
  }

  public getInitCompleted(): Observable<boolean> {
    return this.initCompleted.asObservable();
  }
  private configure() {
    this.setNewDossierEnabled();
    this._setDossierInfoProfiles();
    this._setControlPanelOptionsProfiles();
    /*
    this.setExportEnabled();
    */
    this.subscribe(forkJoin([
      this.propertyService.getProperty('PERFILESEXPORTACIONES', '0;5'),
      this.propertyService.getProperty('FraSelExpediente.habilitarBotonPreparar', '1;50')
    ]).pipe(
      finalize(
        () => this.initCompleted.next(true)
      )),
      (result: any[]) => {

        // Se habilita las exportaciones solo para los perfiles configurados
        result[0] = result[0].replace(new RegExp(/[;]/g), ',');
        if (this.userService.hasRoles(result[0])) {
          this.exportsEnabled = true;

          this.exportProfiles = result[0];
          this.controlPanelProfiles.find(element => element.identifier === 'exportProcess').profiles = this.exportProfiles;
        } else {
          this.exportsEnabled = false;
          this.controlPanelProfiles.find(element => element.identifier === 'exportProcess').profiles = '0,5';
        }
        let clientExportConf = this.appConfig.getValue('documents.exportOption.enabled');
        if (clientExportConf != undefined) {

          this.exportsEnabled = clientExportConf;
        }


        // Se habilita la opción preparar solo para los perfiles configurados
        result[1] = result[1].replace(new RegExp(/[;]/g), ',');
        this.userHasPrepareProjectRoles = this.userService.hasRoles(result[1]);
      }
    )
  }

  private setNewDossierEnabled() {
    let _hasRole = false;
    this.subscribe(this.plycaService.getProcurementProjectSteps('procurementProject/procurementProjectDefinition.json').pipe(
      finalize(() => {
        console.log('Configuración de acceso a nuevo expediente  cargada.');
      }),
      catchError((error: any) => {
        console.log(error);
        this.newDossierEnabled = false;
        return of({});
      })),
      (stepsDef: ProcurementProjectDefinitionsDTO) => {
        stepsDef.definitions.map((step: ProcurementProjectStepsDefinitionDTO) => {
          let _profiles = step.profiles;
          // si el paso no tiene perfiles especificos se asume que es un tipo de ficha para promotor o soporte
          if (!_profiles) {
            // _profiles = '1,50';
            _profiles = this.appConfig.getValue('newdossier.defaultProfiles');
          }
          if (this.userService.hasRoles(_profiles)) {
            _hasRole = true;
          }
        },
          (e) => {
            this.newDossierEnabled = false;
            console.log(e);
          });
        // si esta habilitada la opcion de crear expedientes y el usuario tiene el perfil definido para inciar alguno de los expedintes;
        this.newDossierEnabled = this.appConfig.getValue('newdossier.enabled') && _hasRole;
      }
    );
  }

  public isOptionEnabled(optionId: any, documentClass = '00600'): boolean {
    /* console.log('isOptionEnabled ----->');
     console.log(option.id);
     console.log(documentClass);
 */
    let optionConfiguration;
    if (this.dossierInfoConf) {


      const documentClassfound = this.dossierInfoConf.find((element) => element.documentClass == documentClass);
      // console.log(documentClassfound);
      if (documentClassfound) {

        optionConfiguration = documentClassfound.options.find((element) => element.id == optionId);

        if (optionConfiguration) {
          if (optionConfiguration.visibility == 'false') {
            // console.log('isOptionEnabled <-----');

            return false;
          } else {
            let _profiles = optionConfiguration.profiles;
            if (!_profiles) {
              return true;
            }
            //  console.log('isOptionEnabled <-----');
            return this.userService.hasRoles(_profiles);
          }
        } else {
          return true;
        }

      } else {
        // console.log('isOptionEnabled <-----');
        return true;

      }

    } else {
      return true;
    }

  }

  private _setDossierInfoProfiles(): void {
    this.dossierInfoConf = this.appConfig.getValue('dossierinfo');
    console.log('Configuración de acceso a dossier info cargada.');
  }

  private _setControlPanelOptionsProfiles(): void {
    this.controlPanelEditionProfiles = ControlPanelEditionProfiles;
    this.controlPanelProfiles = ControlPanelProfiles;

    const adaptControlPanelConfig = this.appConfig.getValue('controlPanelConfig');
    // PATCH GROUP CON CONFIGURACION DE ADAPTACION
    if (adaptControlPanelConfig) {
      // 1. GESTION DE ELEMENTOS PERSONALIZADOS
      this._manageCustomElements
      // 2. GESTION DE ELEMENTOS NUEVOS EN ADAPTACION
      this._manageNewAdaptedElements(adaptControlPanelConfig);
    }

    // elementos de edición que no se pintan en el panel de control, pero se acceden a través de el
    this._setEditingProfiles();
  }

  private _manageCustomElements(adaptControlPanelConfig: any): void {
    this.controlPanelProfiles.forEach(element => {
      const _elementAdapted = adaptControlPanelConfig.find(elementAdapted => elementAdapted.identifier === element.identifier);
      if (_elementAdapted) {
        lodash.mergeWith(element, _elementAdapted);
      }
    });
  }

  private _manageNewAdaptedElements(adaptControlPanelConfig: any): void {
    const newElements = adaptControlPanelConfig.filter(
      elementAdapted => this.controlPanelProfiles.find(
        el => el.identifier === elementAdapted.identifier
      ) === undefined
    );

    if (newElements) {
      newElements.forEach(element => {
        element.options = undefined;
      });
      this.controlPanelProfiles.push(...newElements);
    }
  }

  private _setEditingProfiles(): void {
    const customFieldsProfile = this.controlPanelProfiles.find(option => option.linkTo === '/customFields');
    if (customFieldsProfile) {
      this.controlPanelEditionProfiles[0].profiles = customFieldsProfile.profiles;
    }
  }

  public isShowControlPanelMenuOption(): boolean {
    return this.controlPanelProfiles.filter(option => option.type === 'OPTION')
      .find(el => el.profiles === undefined || el.profiles === '' || this.userService.hasRoles(el.profiles)) !== undefined;
  }

  public getControlPanelConfiguration(): any {
    return this.controlPanelProfiles;
  }

  public getControlPanelEditionOption(route: ActivatedRouteSnapshot): any {
    return this.controlPanelEditionProfiles.find(
      option => (route.url.find(
        routeElement => ('/' + routeElement.path === option.linkTo)
      ) != undefined
      )
    );
  }

  public getControlPanelMenuOption(route: ActivatedRouteSnapshot): any {
    let editionOption = this.getControlPanelEditionOption(route);
    if (editionOption !== undefined) {
      return editionOption
    } else {
      return this.controlPanelProfiles.filter(option => option.type === 'OPTION').find(
        option => (route.url.find(
          routeElement => ('/' + routeElement.path === option.linkTo)
        ) !== undefined
        )
      );
    }
  }
  public getControlPanelActionMenuOption(actionClasification: string): any {

    return this.controlPanelProfiles.find(option => (
      option.type === 'OPTION'
      && option.linkTo === '/actions'
      && option.linkParams !== undefined
      && option.linkParams === actionClasification));
  }

  public isUserCanPrepareProject(identifier: string, phaseId: string): Observable<boolean> {

    let cliente = this.appConfig.getValue('cliente');
    //Para expedientes genericos que no tienen tramitación
    const dossierWithoutPrepare = this.appConfig.getValue('newdossier.withoutprepare');
    let valuesArray = undefined;
    if (dossierWithoutPrepare) {
      // Convertir la lista en un array
      valuesArray = dossierWithoutPrepare.split(',');
    }
    if (this.appConfig.getValue('newdossier.enabled') === false) {
      return of(false);
    }

    if (identifier !== undefined) {
      if (!this.userHasPrepareProjectRoles) {
        return of(false);
      } else {
        // Realizar la consulta para obtener el proyecto
        return this.plycaService
          .get(this.configuration.PROJECTENTITY_SERVICE_URL, identifier, {
            expand: 'expansionSet:minimal'
          })
          .pipe(
            switchMap((project: ProjectEntityDTO) => {
              // Verificar si la lista contiene el valor de project.documentClass
              if (valuesArray && valuesArray.includes(project.documentClass.identifier)) {
                return of(false);
              }

              // Verificar si el identificador de fase del proyecto coincide con '0<>EXPFASE'
              // Si no tiene formId, no se puede preparar la FE
              if (project.phase.identifier === '0<>EXPFASE') {
                if (cliente && cliente === 'AYMAD' && this.appConfig.getValue('newdossier.enabled') === true) {
                  // Si es Ayuntamiento de Madrid se consultan procurementProjectDefinition para verificar si está desactivado
                  return this.getProcurementProjectDefinition(project.formId);
                } else {
                  return of(true);
                }

              } else {
                return of(false); // El identificador de fase no coincide, devolver false
              }
            }),
            catchError(error => {
              console.error('Error al obtener el proyecto:', error);
              return of(false); // En caso de error al obtener el proyecto, devolver false
            })
          );
      }
    } else {
      // No se encuentra el identificador del expediente
      return of(phaseId === '0<>EXPFASE' && this.userHasPrepareProjectRoles);
    }
  }

  private getProcurementProjectDefinition(formId: string): Observable<boolean> {
    let url = '/userAPI/v1/projectDefinitions';

    return this.plycaService.query<any>(url).pipe(
      map((result: PaginationDTO<any>) => {
        if (result && result.content) {
          // Convertir cada elemento de result.content al tipo ProcurementProjectDefinitionsDTO
          const defs: ProcurementProjectDefinitionsDTO[] = result.content.map((item: any) => item as ProcurementProjectDefinitionsDTO);
          if (formId) {
            // Buscar el primer paso que coincida con el formId y tenga perfiles definidos
            const selectedStep = defs.reduce((selected: any, def: ProcurementProjectDefinitionsDTO) => {
              // Sino tienen perfiles, o en el caso de que los tenga que sea distinto de vacio
              const step = def.definitions.find((step: any) => step.identifier === formId &&
                ((step.profiles == undefined || step.profiles == null) || (step.profiles !== undefined && step.profiles !== "-1")));
              return step ? step : selected;
            }, null);

            if (selectedStep) {
              console.log('Se permite preparar el formulario:', formId);
              return true; // Se encontró y seleccionó correctamente el paso
            } else {
              console.log('No está activo el formulario:', formId);
              return false; // No se encontró un paso válido para el formulario
            }
          } else {
            console.log('No existe un formulario definido, para este tipo de expediente');
            return false; // El formId no está definido
          }
        } else {
          console.log('No se obtuvo un contenido válido de la consulta.');
          return false; // No se obtuvo contenido válido de la consulta
        }
      }),
      catchError(error => {
        console.error('Error al cargar definiciones de pasos:', error);
        return of(false); // Manejar cualquier error y devolver false
      })
    );
  }

  /*public isUserCanPrepareProject(identifier: string, phaseId: string): Observable<boolean> {
    // TODO: REVISAR LA LÓGICA
    if (identifier != undefined) {
      if (!this.userHasPrepareProjectRoles) {
        return of(false)
      } else {
        // Si tiene los roles, se consulta la fase
        return this.plycaService
          .get(this.configuration.PROJECTENTITY_SERVICE_URL, identifier, {
            expand: 'expansionSet:minimal'
          })
          .pipe(
            map(
              (project: ProjectEntityDTO) => (
                project.phase.identifier === '0<>EXPFASE'
              )
            )

          )
      }

    } else {
      return of(phaseId === '0<>EXPFASE' && this.userHasPrepareProjectRoles);
    }

  }*/

  public isUserCanViewFE(identifier: string, phaseId: string): boolean {
    // TODO: REVISAR LA LÓGICA
    // return phaseId !== '0<>EXPFASE' || !this.userHasPrepareProjectRoles;
    return true;
  }

  public isHasPrepareProjectRoles(): boolean {
    return this.userHasPrepareProjectRoles;
  }

  public isReassignmentEnabled(procedure?: ProcedureDTO): Observable<boolean> {
    return this.propertyService.getProperty('PERFILES_VALIDOS_REASIGNAR').pipe(
      map((propertyValue: string) => {
        let hasReassignProfile = false;
        let profileList = propertyValue.split(';');
        if (this.userService.getUser().hasSignature) {
          profileList = profileList.filter((profile: string) => profile.endsWith('A') || profile.endsWith('F'));
        } else {
          profileList = profileList.filter((profile: string) => profile.endsWith('A') || profile.endsWith('T'));
        }
        profileList = profileList.map((profile: string) => profile.substring(0, profile.length - 1));
        hasReassignProfile = profileList.find((profile: string) => this.userService.hasRoles(profile)) !== undefined;
        //        console.log('Reasignacion tiene perfiles ' + hasReassignProfile);

        if (procedure && procedure.status !== ProcedureStatusDTO.TRAMITE_PAUSADO
          && procedure.status !== ProcedureStatusDTO.TRAMITE_ACTIVO) {
          return false;
        } else if (this.userService.hasRoles('50')) {
          return true;
        } else {
          return hasReassignProfile;
        }
      })
    );
  }

  //Método que devuelve la lista de perfiles asociada a una opción concreta del panel de configuración
  //Parámetros:
  // * group: Nombre del grupo
  // * option: Nombre de la opción
  protected patchProfilesByOPtion(groupIndentifier: string, optionIdentifier: string): string {
    let option;
    // se recuperan todas la opciones y grupos
    let configGroupsConfigurations = this.getControlPanelConfiguration();
    // Se agrupan
    let _groups = configGroupsConfigurations.filter(option => option.type === 'GROUP');
    _groups.forEach(group => {
      if (group.identifier === groupIndentifier) {
        let _options = configGroupsConfigurations.filter(
          option => option.type === 'OPTION' && option.group === group.identifier
            && (option.profiles === undefined || option.profiles === '' || this.userService.hasRoles(option.profiles)));


        if (_options !== undefined && _options.length > 0) {
          option = configGroupsConfigurations.filter(option => option.identifier === optionIdentifier).shift();;
        }
      }

    });
    return option ? option.profiles : undefined;
  }

  ngOnDestroy() {
    this.initCompleted = undefined;
    super.ngOnDestroy();
  }
}
